export enum HealthAskType {
  WhatWeAskOfYou = 'WHAT_WE_ASK_OF_YOU',
  WhatYouCanExpectFromUs = 'WHAT_YOU_CAN_EXPECT_FROM_US'
}

export interface HealthAsk {
  title: string
  message: any
  icon: HealthIconType
  type: HealthAskType
}

export enum HealthIconType {
  Mask = 'MASK',
  Tissue = 'TISSUE',
  SocialDistance = 'SOCIAL_DISTANCE',
  Congregating = 'CONGREGATING',
  MobilePay = 'MOBILE_PAY',
  NoFoodOrDrink = 'NO_FOOD_OR_DRINK',
  TemperatureCheck = 'TEMPERATURE_CHECK',
  Disinfect = 'DISINFECT',
  Seats = 'SEATS'
}
